import type { PlayerResponse, RpmPercentResponse } from '@on3/api';
import { Avatar } from '@on3/ui-lib/components/Avatar';
import { Link } from '@on3/ui-lib/components/Link';
import { createUrl } from '@on3/ui-lib/utils/url';
import { type HTMLProps } from 'react';

import styles from './PredictionStatus.module.scss';

interface IPredictionStatus {
  player?: PlayerResponse;
  rpm: RpmPercentResponse[];
  isPlayerCard?: boolean;
}
export const PredictionStatus = ({
  rpm,
  isPlayerCard,
  player,
}: IPredictionStatus & HTMLProps<HTMLDivElement>) => {
  const { slug, recruitmentKey } = player || {};

  return (
    <Link
      className={styles.block}
      data-ui="player-predictions"
      href={createUrl(['rivals', slug, 'recruiting', recruitmentKey, 'rpm'])}
    >
      {rpm?.map((org) => {
        if (org.organization?.slug) {
          return (
            <div className={styles.prediction} key={org.organization.key}>
              <figure>
                <Avatar
                  altText={org.organization.fullName}
                  domain={org.organization.defaultAsset?.domain}
                  height={20}
                  source={org.organization.defaultAsset?.source}
                  teamAvatar
                  title={org.organization.fullName}
                  type={org.organization.defaultAsset?.type}
                  width={20}
                />
              </figure>
              {!!org.percent && (
                <span className={styles.rpmText}>
                  {Math.round(org.percent)}%
                </span>
              )}
            </div>
          );
        }

        return null;
      })}
    </Link>
  );
};
